import { z } from 'zod';
import { COLOR_SCHEMES, ROLES } from '../roles.js';
export const idSchema = z.string().min(1, 'Ungueltige ID');
export const idParamSchema = z.object({ id: idSchema });
export const roleSchema = z.enum(ROLES);
export const colorSchemeSchema = z.enum(COLOR_SCHEMES);
export const prioritySchema = z.number().int().min(0).max(3);
/** Position (fractional index). Nie vom Client frei waehlbar ausser beim Move. */
export const positionSchema = z.string().min(1).max(200);
/** ISO-8601-Zeitstempel. Der Client sendet immer UTC. */
export const isoDateTimeSchema = z.string().datetime({ offset: true });
export const nullableIsoDateTimeSchema = isoDateTimeSchema.nullable();
/**
 * Concurrency-Token (SPEC 7.2). Jeder PATCH schickt den `updatedAt`-Stand mit,
 * den der Client kennt. Weicht der Server ab, antwortet er mit 409 und dem
 * aktuellen Objekt — Last-Write-Wins auf Feldebene, aber sichtbar fuer den Nutzer.
 */
export const concurrencySchema = z.object({
    updatedAt: isoDateTimeSchema.optional(),
});
export const hexColorSchema = z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/, 'Farbe muss als #rrggbb angegeben werden');
//# sourceMappingURL=common.js.map